import React from "react";
import Skeleton from "react-loading-skeleton";
import styled from "styled-components";
import { Stat, StatsContainer } from "..";

export const Loader: React.FC = () => {
  return (
    <Container>
      <Skeleton height={25} width={250} />
      <BarChart height={400} />
      <StatsContainer>
        {Array.from({ length: 4 }, (_, i) => i).map((idx) => (
          <Stat key={`entries-chart-loader-${idx}`}>
            <Skeleton height={28} width={100} />
            <Skeleton height={20} width={70} />
          </Stat>
        ))}
      </StatsContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  text-align: center;
`;

const BarChart = styled(Skeleton)`
  border-radius: 7px;
  margin: 20px 0;
`;
